import React, {  useState, useEffect } from 'react';
import Select from 'react-select';
import { useQuery } from 'react-query';
import { fetchWorkflows } from 'api/actions/workflows'
import { fetcher } from 'api/client'
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

export function useWorkflowList(options = {}) {
    const [workflows, setWorkflows] = useState({ map: new Map(), array: [] })
    const { onSuccess, ...rest } = options;

    const { isLoading, isFetching, isSuccess, isError, remove } = useQuery('workflows', () => fetcher(fetchWorkflows()), {
        ...rest,
        onSuccess: (data) => {
            const newMap = new Map(
                data.map(d => 
                    ( [ d._id, {label: d.name, value: d._id, ...d } ] )
                )
            )
            const obj = { map: newMap, array: Array.from(newMap.values()) }
            if (onSuccess) onSuccess(obj)
            setWorkflows(obj)
        }
    })

    return { isLoading, isFetching, isSuccess, isError, reset: remove, workflowsMap: workflows.map, workflowsArray: workflows.array }
}

export function WorkflowsSelect({ isDisabled,  value, onChange, ...props }) {
    const [realValue, setRealValue] = useState(null);
    const { isLoading, workflowsArray, isFetching, workflowsMap } = useWorkflowList({
        onSuccess: (workflows) => {
            if (value) {
                setRealValue(workflows.map.get(value))
            }
        }
    });

    useEffect(() => {
        if (workflowsMap.get(value)) {
            setRealValue(workflowsMap.get(value))
        } else {
            setRealValue(null)
        }
    }, [workflowsMap, value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }

    return <Select 
        options={workflowsArray}
        isLoading={isLoading || isFetching}
        isDisabled={isLoading || isDisabled}
        isClearable
        styles={reactSelectStyles} 
        value={realValue}
        onChange={handleChange}
        {...props}
    />
}